import type { StructuralDecorator } from "../decorator.js";
import type { Asked, Rule } from "../rules.js";
import type { AnswersOf, GroupKeyOf, ModulesOf, TypedBy } from "../typedBy.js";

/**
 * When one group is asked, as `showWhen` decides an item's: every item in a
 * group not asked goes unasked with it.
 */
export const showGroupWhen = <Typing extends TypedBy>(
  _typedBy: Typing,
  group: GroupKeyOf<ModulesOf<Typing>>,
  when: Rule<AnswersOf<ModulesOf<Typing>>> | "never",
): StructuralDecorator => ({
  kind: "structural",
  group: (view) =>
    view.at.group === group
      ? {
          ...view,
          // As for `showWhen`.
          asked: when as Asked,
        }
      : view,
});
